import InternalBookingCardBase from '../common/InternalBookingCardBase';
import { extractUpgradeSymbols } from '../../../../util/upgradeSymbolsHelper';

function BookingCardRallyev2({
  booking,
  handleOpenModal,
  renderAvailableSlots,
  rowHeight,
  onBookingShift,
  entertainment,
  onDragStart,
  onDragActivated,
  onDragEnd,
  availableShiftTimes,
  isShiftable,
}) {
  const color = '#ffffff';

  const upgradeSymbols = extractUpgradeSymbols(booking);

  const handleCardClick = (bookingId, borderColor) => {
    handleOpenModal(bookingId, borderColor);
  };

  const participantCount =
    booking?.participantCount ?? booking?.laneCount ?? booking?.groupParticipantCount ?? 0;

  return (
    <InternalBookingCardBase
      booking={booking}
      getParticipantCount={bk => bk?.participantCount ?? bk?.laneCount ?? bk?.groupParticipantCount ?? 0}
      onCardClick={handleCardClick}
      renderAvailableSlots={renderAvailableSlots}
      rowHeight={rowHeight}
      onBookingShift={onBookingShift}
      entertainment={entertainment}
      onDragStart={onDragStart}
      onDragActivated={onDragActivated}
      onDragEnd={onDragEnd}
      availableShiftTimes={availableShiftTimes}
      isShiftable={isShiftable}
      iconProps={{
        upgrades: upgradeSymbols,
        manualUpgrades: [],
        participantCount,
        slotMode: false,
        color,
      }}
      color={color}
    />
  );
}

export default BookingCardRallyev2;

